import { DetailedProductFieldsFragment } from "client/graphql/storefront-api"
import { ProductTitle } from "client/packages/commerce/components/ui/textStyles"
import { Dispatch, SetStateAction } from "react"
import styled from "styled-components"

import { Price } from "../ui/priceComponents/Price"

import ImageCarousel from "./ImageCarousel"

export const PreviewWrapper = styled.div`
  background-color: ${(props) => props.theme.background};
  display: flex;
  justify-content: center;
  flex-direction: column;
`

export const ProductDetails = styled.div`
  margin-top: 10px;

  ${ProductTitle} {
    margin: 15px 0 20px;
  }
`

export interface ProductPreviewProps {
  product: DetailedProductFieldsFragment
  price?: string | number
  openImageGallery?: Dispatch<SetStateAction<number>>
}

const ProductPreview = ({
  product,
  price,
  openImageGallery = () => {},
}: ProductPreviewProps) => (
  <PreviewWrapper>
    <ImageCarousel product={product} openImageGallery={openImageGallery} />
    <ProductDetails>
      <ProductTitle>{product.title}</ProductTitle>
      {price && (
        <Price
          currencyCode={product.priceRange.minVariantPrice.currencyCode}
          amount={price}
        />
      )}
    </ProductDetails>
  </PreviewWrapper>
)

export default ProductPreview
